import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { DispenserAgreementsSubmitPayload, DispenserAgreementUpdatePayload } from '../../../models/dispensers.model'
import { AgreementType } from '../../../models/enum/agreement.enum'
import { SharedValue } from '../../../models/enum/shared.enum'
import { IAgreement, IAgreementEntry } from '../../../models/interface/agreement.interface'
import { IHistoryList } from '../../../models/interface/history-list.interface'
import { ISharedPagination } from '../../../models/interface/shared.interface'
import { AgreementService } from '../agreement.service'

@Injectable({
  providedIn: 'root'
})
export class DispenserAgreementService {
  constructor(private agreementService: AgreementService) {}

  public getAgreements(params?: ISharedPagination): Observable<IHistoryList> {
    return this.agreementService.getAgreements(AgreementType.DISPENSER_AGREEMENT, params)
  }

  public getAgreementDetail(code: string, isDrawDown: boolean = false): Observable<IAgreement> {
    return this.agreementService.getAgreementDetail(code, isDrawDown)
  }

  public getAgreementDetailEntries(code: string, params?: ISharedPagination): Observable<IHistoryList> {
    return this.agreementService.getAgreementDetailEntries(code, AgreementType.DISPENSER_AGREEMENT, params)
  }

  public getAgreementDetailAllEntries(code: string): Observable<IAgreementEntry[]> {
    return this.getAgreementDetail(code, true).pipe(
      map((res) => {
        if (!res.entries) {
          throw new Error(SharedValue.errorTryAgain)
        }
        return res.entries
      })
    )
  }

  public getDispenserCategories(folType: string): Observable<any> {
    return this.agreementService.getDispenserCategories(folType)
  }

  public getDispenserTypes(): Observable<any> {
    return this.agreementService.getDispenserTypes()
  }

  public getServiceProducts(serviceType: string): Observable<any> {
    return this.agreementService.getServiceProducts(serviceType)
  }

  public getCategoryProducts(payload: any): Observable<any> {
    return this.agreementService.getCategoryProducts(payload)
  }

  public submitDispenserAgreement(payload: DispenserAgreementsSubmitPayload): Observable<any> {
    return this.agreementService.submitDispenserAgreement(payload)
  }

  public getEndCustomerAddress(agreementCode: string): Observable<any> {
    return this.agreementService.getEndCustomerAddress(agreementCode)
  }

  public getDistributorAddresses(agreementCode: string): Observable<any> {
    return this.agreementService.getDistributorWarehouses(agreementCode)
  }

  public placeDispenserOrder(payload: any, agreementCode: string): Observable<any> {
    return this.agreementService.placeDispenserOrder(payload, agreementCode)
  }

  public downloadCreditRequestForm(): Observable<any> {
    return this.agreementService.downloadRequestForm('dispenser')
  }

  public uploadCreditRequestForm(file: any): Observable<any> {
    return this.agreementService.uploadRequestForm('dispenser', file)
  }

  public downloadOpenShipmentOrders(): Observable<any> {
    return this.agreementService.downloadOpenShipmentOrders()
  }

  public updateDispenserAgreement(
    userdId: string,
    code: string,
    payload: DispenserAgreementUpdatePayload
  ): Observable<any> {
    return this.agreementService.updateDispenserAgreement(userdId, code, payload)
  }

  public cancelDispenserAgreement(code: string): any {
    return this.agreementService.cancelDispenserAgreement(code)
  }
}
